var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

$(document).ready(function() {
  thumbnails = $('img[src*="/products/"]').not(':first');
  if (thumbnails.length) {
    thumbnails.bind('click', function() {
      var arrImage = $(this).attr('src').split('?')[0].split('.');
      var strExtention = arrImage.pop();
      var strRemaining = arrImage.pop().replace(/_[a-zA-Z0-9@]+$/,'');
      var strNewImage = arrImage.join('.')+"."+strRemaining+"."+strExtention;
      if (typeof variantImages[strNewImage] !== 'undefined') {
          productOptions.forEach(function (value, i) {
           optionValue = variantImages[strNewImage]['option-'+i];
           if (optionValue !== null && $('.single-option-selector:eq('+i+') option').filter(function() { return $(this).text() === optionValue }).length) {
             $('.single-option-selector:eq('+i+')').val(optionValue).trigger('change');
           }
        });
      }
    });
  }
});

//Accordian
const accordionItems = document.querySelectorAll('.accordion-item a');

function toggleAccordion () {
  this.classList.toggle('active');
  this.nextElementSibling.classList.toggle('active');
}

accordionItems.forEach(item => item.addEventListener('click', toggleAccordion))


//ATL
  $(document).ready(function(){

    var check; 

    // ATL script
    $("#authorityterms").on("click", function(){
        if(authorityterms.checked) {
            alert("By agreeing to these Authority to Leave Terms & Conditions, you authorise our Courier to leave your order without a signature. Delivery instructions, such as 'leave at the front door', should be provided in the Additional Instructions about delivery");
        } else {
            alert("If you do not give Authority to Leave, you will then need to be in attendance at your delivery address to sign for, and receive the goods during normal business hours. Your goods may be returned to sender after attempted deliveries.");
        }
    }); 
  
  });

//Search
    $(document).ready(function() {
    	$(".search").on("mouseout", function() {
    		var ss = $(this).width();
    		// alert(ss);
    		if (ss > 100) {
    			$("#autocomplete-results").hover(function() {
    				$('.ui-autocomplete').show();
    			}, function() {
    				$('.ui-autocomplete').hide();
    			});
    		} else {
    			$('.ui-autocomplete').show();
    		}
    	});
    });

// Refresh cart when back from check out page
    $(document).ready(function() {
      if (performance.navigation.type == 2) {
        console.log('Back');

        $.ajax({
            url: "/search",
            beforeSend: function () {
                $(".cart-window-body").addClass("loading");
            },
            success: function (e) {
                if (0 < $("div#cart-sidebar").length) {
                    $("div#cart-sidebar").html($(e).find("div#cart-sidebar").html());
                    
                    $("div#cart_block").html($(e).find("div#cart_block").html());
                    $("div#cart_popup").html($(e).find("div#cart_popup").html());
                    $(".mobile-nav-cart").html($(e).find(".mobile-nav-cart").html());
                    $("#filter-cart").html($(e).find("#filter-cart").html());
                    if (window.show_multiple_currencies) {
                      theme.CurrencyPicker.convert("#cart_block .money"); 
                      theme.CurrencyPicker.convert("#cart_popup .money"); 
                      theme.CurrencyPicker.convert("#cart-sidebar .money");
                      roar.handleReviews();
                    }
                }
            },
            error: function (e) {
                console.log(e);
            },
        }).done(function () {
            $(".cart-window-body").removeClass("loading");
        });
      }
    });

$(document).ready(function() {
  window.addEventListener("scroll", function() {
    250 < $(window).scrollTop() ? $("#shopify-section-mobile-nav").addClass("fixed-header") : $("#shopify-section-mobile-nav").removeClass("fixed-header")
  });
});